import { render, staticRenderFns } from "./VacationsTeam.vue?vue&type=template&id=820ddd6c"
import script from "./VacationsTeam.vue?vue&type=script&lang=js"
export * from "./VacationsTeam.vue?vue&type=script&lang=js"
import style0 from "./VacationsTeam.vue?vue&type=style&index=0&id=820ddd6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports